import { IStrikeZoneDecision, getEffectiveStrikeZoneLocations } from '@trackman/baseball-shared-components';

export interface IStrikeZonePlate {
  id: number;
  strikeZoneCalculationType: 'Front' | 'Middle' | 'Back';
  offset: number;
  extension: number;
}

export type StrikeZoneDecisionInput = Pick<IStrikeZoneDecision, 'strikeZone' | 'strikeZoneDecisionLocations'>;

export const getStrikeZonePlates = (strikeZoneDecision?: StrikeZoneDecisionInput | null): IStrikeZonePlate[] => {
  const locations = getEffectiveStrikeZoneLocations(strikeZoneDecision?.strikeZone);

  return (
    strikeZoneDecision?.strikeZoneDecisionLocations?.map((decisionLocation, idx) => {
      const location = locations.find((x) => x.locationType === decisionLocation.strikeZoneLocationType);

      return {
        id: idx,
        strikeZoneCalculationType: decisionLocation.strikeZoneLocationType,
        offset: location?.offsetY || 0,
        extension: location?.bottomExtension || 0,
      };
    }) || []
  );
};
